import type { ProductType, Weight } from '@iheartjane/types';

import { EXTRACT, FLOWERS, OTHERS } from './constants';

const AllPriceTypes = [
  'sativa',
  'hybrid',
  'indica',
  'cbd',
  'extract',
  'vape',
  'flower',
] as const;
type PriceTypeTuple = typeof AllPriceTypes;
type PriceType = PriceTypeTuple[number];

export const isPriceType = (value: string): value is PriceType => {
  return AllPriceTypes.includes(value as PriceType);
};

const PRICES: { [K in PriceType]: Weight[] } = {
  cbd: FLOWERS,
  extract: EXTRACT,
  flower: FLOWERS,
  hybrid: FLOWERS,
  indica: FLOWERS,
  sativa: FLOWERS,
  vape: EXTRACT,
};

export function getMenuPrices(type: ProductType): Weight[] {
  return isPriceType(type) ? PRICES[type] : OTHERS;
}
